import { CheckCircle2, Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type Props = {
  isOpen: boolean;
  closeFn: () => void;
  requestID: string | null;
};

function ResponseResultDialog({ closeFn, isOpen, requestID }: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeFn()}>
      <DialogContent
        className="max-w-[320px] overflow-hidden rounded-xl border-0 p-0 shadow-xl"
        overlayClass="backdrop-blur-sm bg-gradient-to-br from-purple-500/10 to-indigo-500/20"
      >
        {/* Success Animation Background */}
        <div className="relative overflow-hidden">
          {/* Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-purple-600" />

          {/* Pattern Overlay */}
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                'radial-gradient(circle, white 1px, transparent 1px)',
              backgroundSize: '16px 16px',
            }}
          />

          {/* Animated Sparkles */}
          <div className="absolute -right-2 top-4">
            <Sparkles className="h-6 w-6 animate-pulse text-amber-200/70" />
          </div>
          <div className="absolute -left-2 top-12">
            <Sparkles className="h-4 w-4 animate-pulse text-indigo-200/70" />
          </div>

          {/* Success Icon */}
          <div className="flex flex-col items-center justify-center p-6">
            <div className="relative flex h-20 w-20 items-center justify-center">
              <div className="absolute h-full w-full animate-ping rounded-full bg-white/20 opacity-75"></div>
              <div className="absolute h-full w-full animate-pulse rounded-full bg-white/10"></div>
              <CheckCircle2 className="relative h-16 w-16 text-white" />
            </div>

            <h2 className="mt-3 text-center font-medium text-white">
              تمت عملية التحويل بنجاح
            </h2>
          </div>
        </div>

        {/* Content Section */}
        <div className="p-4">
          <DialogHeader className="pb-2">
            <DialogTitle className="text-center text-lg font-semibold text-indigo-700 dark:text-indigo-400">
              تم إنشاء طلبية وارد جديدة
            </DialogTitle>
            <DialogDescription className="text-center text-sm text-gray-500">
              يمكنك عرض الطلبية برقم
            </DialogDescription>
          </DialogHeader>

          {/* Request ID */}
          <div className="my-3 rounded-lg bg-gradient-to-r from-indigo-50 to-purple-50 p-3 text-center dark:from-indigo-950/50 dark:to-purple-950/50">
            <span className="text-xl font-bold tracking-wide text-indigo-700 dark:text-indigo-400">
              #{requestID}
            </span>
          </div>

          {/* Actions */}
          <DialogFooter className="mt-3 flex gap-2">
            <Button
              onClick={closeFn}
              variant="outline"
              className="flex-1 border-indigo-200 text-xs text-indigo-700 hover:bg-indigo-50 dark:border-indigo-700/40 dark:text-indigo-400 dark:hover:bg-indigo-950/50"
            >
              إغلاق
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ResponseResultDialog;
